'use strict';

require('./cn-head.scss');

module.exports = {
  template: require('./cn-head.html'),
  controller: require('./cn-head.controller'),
  controllerAs: 'vm',
  transclude: true,

  bindings: {
    h: '@',
    hr: '@',
    titleText: '@',
    subtitleText: '@',
    leadText: '@',
    labelText: '@',
    reverse: '<',
    trailingTitleText: '@',
    helpTextKey: '@'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-head/cn-head/index.js
 ** module id = 32
 ** module chunks = 0
 **/